import { render, staticRenderFns } from "./MultiExcelCandidate.vue?vue&type=template&id=88284d88&"
import script from "./MultiExcelCandidate.vue?vue&type=script&lang=js&"
export * from "./MultiExcelCandidate.vue?vue&type=script&lang=js&"
import style0 from "./MultiExcelCandidate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports